import React, { useCallback, useState } from "react";
import ModalSkuMapEditActionWrap from "./ModalSkuMapEditActionWrap";
import styled from "styled-components";
import { Modal } from "reactstrap";
import Headline from "../Headline";
import i18next from "i18next";
import "react-datepicker/dist/react-datepicker.css";

interface ModalSkuMapEditProps {
  selectedPocMapId?: any;
  closeModal: (shouldUpdate: boolean) => void;
  isOpen: boolean;
  collection: any[];
  selectedRows?: any;
  modalAction: string;
}

const ModalWrapper = styled.div`
  .search {
    padding-top: 3px;
  }
`;

const TableDetails = styled.div`
  flex-grow: 1;

  table {
    background: #fff;
  }
  table,
  td,
  th {
    border: 1px solid #e2e2e2;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }

  th {
    text-align: left;
    font-size: 10px;
    padding: 5px 5px;
    font-weight: 500;
    color: #6d6d6d;
  }
  td {
    font-size: 10px;
    text-align: left;
    padding: 5px 5px;
    min-height: 40px;
  }

  button {
    font-size: 8px;
  }

  tr + tr {
    border-top: 1px solid #e2e2e2;
  }
`;

const Head = styled.div`
  padding: 12px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

const ModalSkuMapEdit: React.FC<ModalSkuMapEditProps> = ({
  selectedPocMapId,
  closeModal,
  isOpen,
  collection,
  selectedRows,
  modalAction,
}) => {
  const [needsRefresh, setNeedsRefresh] = useState(false);

  const handleClose = useCallback(() => {
    closeModal(needsRefresh);
  }, [closeModal, needsRefresh]);

  const handleDataChanged = useCallback(() => {
    setNeedsRefresh(true);
  }, []);

  return (
    <ModalWrapper>
      <div className="modal-wrapper">
        <Modal isOpen={isOpen} scrollable={true}>
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              {modalAction === "edit"
                ? i18next.t("title_edit_sku_mapping")
                : i18next.t("title_create_sku_mapping")}
            </h5>

            <button
              type="button"
              onClick={handleClose}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <TableDetails>
              <Head>
                <Headline disableMargin>
                  {i18next.t("selected_products")}
                </Headline>
              </Head>

              <table>
                <thead>
                  <tr>
                    <th>{i18next.t("depot_name")}</th>
                    <th>{i18next.t("code")}</th>
                    <th>{i18next.t("description")}</th>
                  </tr>
                </thead>

                <tbody>
                  {collection &&
                    collection.map((rowData, index) => (
                      <tr key={index}>
                        <td>{rowData.depotName}</td>
                        <td>{rowData.product.code}</td>
                        <td>{rowData.product.description}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </TableDetails>
            <ModalSkuMapEditActionWrap
              selectedPocMapId={selectedPocMapId}
              closeModal={closeModal}
              onDataChanged={handleDataChanged}
              isOpen={isOpen}
              collection={collection}
              selectedRows={selectedRows}
              modalAction={modalAction}
            />
          </div>
        </Modal>
      </div>
    </ModalWrapper>
  );
};

export default ModalSkuMapEdit;
